<template>
  <div>
    <div class="top-collapse-card">
      <div
        class="top-collapse-card-body"
        :class="collapse ? 'show-all' : 'show-a-part'"
      >
        <slot name="content" style="width: 100%;"></slot>
      </div>

      <div class="top-collapse">
        <a-button @click="collapse = !collapse" type="circle">
          <a-icon type="down" v-if="!collapse" />
          <a-icon type="up" v-else />
        </a-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {},
  data() {
    return {
      collapse: false,
    };
  },
  methods: {},
};
</script>
<style lang="css" scoped>
.top-collapse-card {
  border: 1px solid #eee;
  padding: 10px;
}
.top-collapse {
  text-align: center;
  margin-top: 10px;
}
.top-collapse-card >>> .show-a-part.top-collapse-card-body {
  height: 60px;
  clear: both;
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  max-height: 60px;
  width: 100%;
}

.top-collapse-card >>> .show-all.top-collapse-card-body {
  min-height: 50px;
}
</style>
